import type { ButtonType } from 'antd/es/button';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import type { ReactNode } from 'react';
import { Link, type LinkProps } from '@tanstack/react-router';
import { Button, Popconfirm, Tooltip } from 'antd';

type TableActionsButtonBaseProps = {
    id: string;
    type?: ButtonType;
    icon?: React.ReactNode;
    label?: string;
    tooltip?: string;
    disabled?: boolean;
    danger?: boolean;
    confirm?: ReactNode;
    block?: boolean;
    size?: SizeType;
    loading?: boolean;
    visible?: boolean;
    link?: LinkProps;
    onClick?: () => void;
};

export type TableActionsButtonProps = TableActionsButtonBaseProps & {
    rightButton?: TableActionsButtonBaseProps;
};

export function TableActionsButton({
    type = 'primary',
    icon,
    label,
    tooltip,
    disabled = false,
    danger,
    confirm,
    block,
    size,
    loading,
    link,
    onClick,
}: TableActionsButtonBaseProps) {
    let button = (
        <Button
            block={block}
            danger={danger}
            disabled={disabled}
            icon={icon}
            loading={loading}
            onClick={confirm ? undefined : onClick}
            size={size}
            type={type}
        >
            {label}
        </Button>
    );

    if (tooltip) {
        button = <Tooltip title={tooltip}>{button}</Tooltip>;
    }

    if (confirm) {
        button = (
            <Popconfirm onConfirm={onClick} title={confirm}>
                {button}
            </Popconfirm>
        );
    }

    if (link) {
        button = <Link {...link}>{button}</Link>;
    }

    return button;
}
